/** A tiny cursor over a normalized string, matching sticky regexes at the current position. */
export class Scanner {
  pos = 0;
  constructor(
    readonly s: string,
    /** Characters that may not directly follow a match ending in a word character. */
    private readonly wordChar: RegExp = /[a-z0-9]/,
  ) {}

  /** Skips whitespace. */
  ws(): void {
    while (this.pos < this.s.length && /\s/.test(this.s[this.pos] as string)) this.pos++;
  }

  done(): boolean {
    this.ws();
    return this.pos >= this.s.length;
  }

  /** Matches `re` (compiled with the `y` flag) after optional whitespace; advances on success. */
  eat(re: RegExp): RegExpExecArray | null {
    const start = this.pos;
    this.ws();
    re.lastIndex = this.pos;
    const m = re.exec(this.s);
    if (m && m[0].length > 0) {
      const end = this.pos + m[0].length;
      const last = m[0][m[0].length - 1] as string;
      const next = this.s[end];
      if (!(this.wordChar.test(last) && next !== undefined && this.wordChar.test(next))) {
        this.pos = end;
        return m;
      }
    }
    this.pos = start;
    return null;
  }

  /** Runs `fn`; restores the position if it returns undefined/null. */
  try<T>(fn: () => T | null | undefined): T | null {
    const start = this.pos;
    const r = fn();
    if (r === null || r === undefined) {
      this.pos = start;
      return null;
    }
    return r;
  }
}

/** Builds a sticky, case-sensitive regex (inputs are lowercased beforehand). */
export const rx = (src: string) => new RegExp(src, "y");
